import React, { Component } from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import Address from "../../searchresults/Address";
import { getDate, getDobDate } from "../../common/DisplayDate";
import getPersonName from "../../common/Name";
import getSsn from "../../common/Ssn";
import SimpleAccordionContent from "../../common/SimpleAccordionContent";

class ConcealedWeaponsPermits extends Component {
  state = {
    rows: [],
    savedResultID: "",
    internalID: "",
  };

  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    const { internalID, savedResultID } = nextProps.additionalData;
    if (
      this.state.internalID !== internalID ||
      this.state.savedResultID !== savedResultID
    ) {
      this.setState({ internalID, savedResultID });
      this.loadData(nextProps);
    }
  }

  loadData = (props) => {
    const rows = [];
    let recCount = 0;
    if (props.reportData !== undefined) {
      const { isSilverReport } = this.props;
      if (isSilverReport) {
        const { node } = this.props;
        if (node && node.length > 0) {
          _.forEach(node, (record, index) => {
            const holderEntity = _.get(record, "holder[0].entity[0]");
            if (holderEntity) {
              rows.push(
                <Table.Row
                  key={`row_con_weap_name_${index}`}
                  className={index % 2 === 1 ? "table-row-odd-child" : ""}
                >
                  <Table.Cell width={3}> Name: </Table.Cell>
                  <Table.Cell width={7}>
                    {getPersonName(
                      _.get(holderEntity, "name[0].firstName[0]._", ""),
                      _.get(holderEntity, "name[0].middleName[0]._", ""),
                      _.get(holderEntity, "name[0].lastName[0]._", ""),
                      props
                    )}
                  </Table.Cell>
                  <Table.Cell width={2}>Permit Number:</Table.Cell>
                  <Table.Cell width={3}>
                    {_.get(record, "permitNumber[0]._", "")}
                  </Table.Cell>
                </Table.Row>
              );
              rows.push(
                <Table.Row
                  key={`row_con_weap_address_${index}`}
                  className={index % 2 === 1 ? "table-row-odd-child" : ""}
                >
                  <Table.Cell width={3}> Address: </Table.Cell>
                  <Table.Cell width={8}>
                    <Address
                      addressNode={_.get(holderEntity, "address[0]")}
                      {...this.props}
                    />
                  </Table.Cell>
                  <Table.Cell width={2}>Expiration Date:</Table.Cell>
                  <Table.Cell width={3}>
                    {getDate(_.get(record, "expiryDate[0]"))}
                  </Table.Cell>
                </Table.Row>
              );
              rows.push(
                <Table.Row
                  key={`row_con_weap_gender_${index}`}
                  className={index % 2 === 1 ? "table-row-odd-child" : ""}
                >
                  <Table.Cell width={3}> Gender: </Table.Cell>
                  <Table.Cell width={8}>
                    {_.get(record, "gender[0]._", "")}
                  </Table.Cell>
                  <Table.Cell width={2} />
                  <Table.Cell width={3} />
                </Table.Row>
              );
              recCount += 1;
            }
          });
        }
      } else {
        const records = _.get(
          props.reportData,
          "personReport.compReportResponse[0].individual[0].weaponPermits[0].weaponPermit"
        );
        if (records !== undefined) {
          _.forEach(records, (record, index) => {
            rows.push(
              <Table.Row
                key={`row_con_weap_name_${index}`}
                className={index % 2 === 1 ? "table-row-odd-child" : ""}
              >
                <Table.Cell width={3}> Name: </Table.Cell>
                <Table.Cell width={7}>
                  {getPersonName(
                    _.get(record, "name[0].first[0]._", ""),
                    _.get(record, "name[0].middle[0]._", ""),
                    _.get(record, "name[0].last[0]._", ""),
                    props
                  )}
                </Table.Cell>
                <Table.Cell width={2}>Permit Number:</Table.Cell>
                <Table.Cell width={3}>
                  {_.get(record, "permit[0].permitNumber[0]._", "")}
                </Table.Cell>
              </Table.Row>
            );

            rows.push(
              <Table.Row
                key={`row_con_weap_address_${index}`}
                className={index % 2 === 1 ? "table-row-odd-child" : ""}
              >
                <Table.Cell width={3}> Address: </Table.Cell>
                <Table.Cell width={8}>
                  <Address addressNode={record.address[0]} {...this.props} />
                </Table.Cell>
                <Table.Cell width={2}>Expiration Date:</Table.Cell>
                <Table.Cell width={3}>
                  {getDate(_.get(record, "permit[0].expirationDate[0]"))}
                </Table.Cell>
              </Table.Row>
            );

            rows.push(
              <Table.Row
                key={`row_con_weap_dob_${index}`}
                className={index % 2 === 1 ? "table-row-odd-child" : ""}
              >
                <Table.Cell width={3}> Date of Birth: </Table.Cell>
                <Table.Cell width={8}>
                  {getDobDate(_.get(record, "DOB[0]"), {
                    userAccount: this.props.userAccount,
                  })}
                </Table.Cell>
                <Table.Cell width={2}>State:</Table.Cell>
                <Table.Cell width={3}>
                  {_.get(record, "stateName[0]._", "")}
                </Table.Cell>
              </Table.Row>
            );

            const registrationDate = _.get(
              record,
              "permit[0].registrationDate[0]"
            );
            rows.push(
              <Table.Row
                key={`row_con_weap_ssn_${index}`}
                className={index % 2 === 1 ? "table-row-odd-child" : ""}
              >
                <Table.Cell width={3}> SSN: </Table.Cell>
                <Table.Cell width={8}>
                  {getSsn(_.get(record, "SSN[0]._"), this.props)}
                </Table.Cell>
                <Table.Cell width={2}>Registration Date:</Table.Cell>
                <Table.Cell width={3}>
                  {registrationDate && getDate(registrationDate)}
                </Table.Cell>
              </Table.Row>
            );

            rows.push(
              <Table.Row
                key={`row_con_weap_gender_${index}`}
                className={index % 2 === 1 ? "table-row-odd-child" : ""}
              >
                <Table.Cell width={3}> Gender: </Table.Cell>
                <Table.Cell width={8}>
                  {_.get(record, "sex[0]._", "")}
                </Table.Cell>
                <Table.Cell width={2} />
                <Table.Cell width={3} />
              </Table.Row>
            );

            rows.push(
              <Table.Row
                key={`row_con_weap_race_${index}`}
                className={index % 2 === 1 ? "table-row-odd-child" : ""}
              >
                <Table.Cell width={3}> Race: </Table.Cell>
                <Table.Cell width={8}>
                  {_.get(record, "sex[0]._", "")}
                </Table.Cell>
                <Table.Cell width={2} />
                <Table.Cell width={3} />
              </Table.Row>
            );
            recCount += 1;
          });
        } else {
          rows.push(
            <Table.Row key={`no_recs_row`}>
              <Table.Cell colSpan={2}>No Records found</Table.Cell>
            </Table.Row>
          );
        }
      }
    }
    if (recCount < 1 && rows.length < 1) {
      rows.push(
        <Table.Row key={`no_recs_row`}>
          <Table.Cell colSpan={2}>No Records found</Table.Cell>
        </Table.Row>
      );
    }
    this.setState({ rows });
    props.updateItemCountBySection(props.sectionName, recCount);
  };

  render() {
    return (
      <SimpleAccordionContent
        {...this.props}
        name={"Concealed Weapons Permits"}
        rows={this.state.rows}
      />
    );
  }
}

export default ConcealedWeaponsPermits;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/ConcealedWeaponsPermits.js